/* ThreadsBloom cart drawer — works with Dawn's <cart-drawer> (cart-drawer.js) */
(() => {
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const SECTIONS = ['cart-drawer', 'cart-icon-bubble'];
  const OPTOUT_KEY = 'bt_protection_optout';
  const upsellCache = {};
  let syncing = false;
  const legacyTried = new Set();

  const drawer = () => document.querySelector('cart-drawer');
  const inner = () => document.querySelector('#CartDrawer .drawer__inner');
  const cartRoot = () => document.querySelector('#CartDrawer .bt-cart');

  const optedOut = () => { try { return sessionStorage.getItem(OPTOUT_KEY) === '1'; } catch (e) { return false; } };
  const setOptOut = (v) => { try { v ? sessionStorage.setItem(OPTOUT_KEY, '1') : sessionStorage.removeItem(OPTOUT_KEY); } catch (e) {} };

  function setBusy(on) { const r = cartRoot(); if (r) r.classList.toggle('is-busy', on); }

  function showError(msg) {
    const el = document.querySelector('#CartDrawer .bt-cart__error');
    if (!el) return;
    el.textContent = msg || 'Something went wrong. Please try again.';
    el.hidden = false;
  }

  async function post(url, body) {
    const res = await fetch(ROOT + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...body, sections: SECTIONS, sections_url: window.location.pathname }),
    });
    const data = await res.json();
    if (!res.ok || data.status) throw data;
    return data;
  }

  function applySections(sections) {
    if (!sections) return;
    const html = sections['cart-drawer'];
    if (html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newInner = doc.querySelector('.drawer__inner');
      const target = inner();
      if (newInner && target) target.innerHTML = newInner.innerHTML;
      const nd = doc.querySelector('cart-drawer');
      const d = drawer();
      if (nd && d) d.classList.toggle('is-empty', nd.classList.contains('is-empty'));
    }
    const bubbleHtml = sections['cart-icon-bubble'];
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubbleHtml && bubble) {
      const doc = new DOMParser().parseFromString(bubbleHtml, 'text/html');
      const s = doc.querySelector('.shopify-section');
      if (s) bubble.innerHTML = s.innerHTML;
    }
  }

  function notify(data) {
    if (window.publish && window.PUB_SUB_EVENTS) {
      try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bt-cart', cartData: data }); } catch (e) {}
    }
  }

  async function change(key, quantity, { silent = false } = {}) {
    if (!silent) setBusy(true);
    try {
      const data = await post('cart/change.js', { id: key, quantity });
      applySections(data.sections);
      notify(data);
      await afterRender();
    } catch (e) {
      showError(e && (e.description || e.message));
    } finally { setBusy(false); }
  }

  async function add(variantId, quantity = 1, { silent = false } = {}) {
    if (!silent) setBusy(true);
    try {
      const data = await post('cart/add.js', { items: [{ id: Number(variantId), quantity }] });
      applySections(data.sections);
      notify(data);
      await afterRender();
      return true;
    } catch (e) {
      showError(e && (e.description || e.message));
      return false;
    } finally { setBusy(false); }
  }

  /* Keep protection in sync + header count + upsell */
  async function afterRender() {
    const r = cartRoot();
    if (!r) return;
    const visible = Number(r.dataset.visibleCount || 0);
    const protVariant = r.dataset.protVariant;
    const protQty = Number(r.dataset.protQty || 0);
    const protKey = r.dataset.protKey;
    const legacyKey = r.dataset.legacyKey;

    patchHeaderCount(visible);

    /* Remove old Kaching protection item left in carts from before the switch */
    if (!syncing && legacyKey && !legacyTried.has(legacyKey)) {
      legacyTried.add(legacyKey);
      syncing = true; await change(legacyKey, 0, { silent: true }); syncing = false;
      return afterRender();
    }

    if (!syncing && protVariant) {
      if (visible > 0 && protQty === 0 && !optedOut()) {
        syncing = true; await add(protVariant, 1, { silent: true }); syncing = false; return;
      }
      if (visible === 0 && protQty > 0 && protKey) {
        syncing = true; await change(protKey, 0, { silent: true }); syncing = false; return;
      }
      if (protQty > 1 && protKey) {
        syncing = true; await change(protKey, 1, { silent: true }); syncing = false; return;
      }
    }
    loadUpsell();
  }

  function patchHeaderCount(count) {
    const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    if (!bubble) return;
    if (count === 0) { bubble.remove(); return; }
    const num = bubble.querySelector('[aria-hidden="true"]');
    if (num) num.textContent = count < 100 ? count : '';
  }

  /* Personalized products must go through the product page (Custom Name field) */
  const CUSTOM_RE = /custom name/i;
  function guardPersonalized(card) {
    const titleEl = card.querySelector('.bt-upcard__title');
    if (!titleEl || !CUSTOM_RE.test(titleEl.textContent)) return;
    const btn = card.querySelector('[data-bt-upsell-add]');
    if (!btn) return; // section already renders a "Personalize" link
    card.querySelectorAll('.bt-upcard__select').forEach((s) => s.remove());
    const link = document.createElement('a');
    link.href = titleEl.getAttribute('href');
    link.className = 'bt-upcard__add';
    link.style.cssText = 'display:flex;align-items:center;justify-content:center;text-decoration:none;';
    link.textContent = 'Personalize \u2192';
    btn.replaceWith(link);
  }

  /* Upsell */
  async function loadUpsell() {
    const box = document.querySelector('#CartDrawer [data-bt-upsell]');
    if (!box) return;
    const pid = box.dataset.productId;
    if (!pid) return;
    const exclude = (box.dataset.exclude || '').split(',').filter(Boolean);
    let html = upsellCache[pid];
    if (!html) {
      try {
        const res = await fetch(`${ROOT}recommendations/products?product_id=${pid}&limit=10&section_id=bt-cart-upsell`);
        html = await res.text();
        upsellCache[pid] = html;
      } catch (e) { return; }
    }
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const cards = [...doc.querySelectorAll('.bt-upcard')].filter((c) => !exclude.includes(c.dataset.productId)).slice(0, 9);
    const liveBox = document.querySelector('#CartDrawer [data-bt-upsell]');
    if (!liveBox || !cards.length) return;
    const track = liveBox.querySelector('.bt-upsell__track');
    track.innerHTML = '';
    cards.forEach((c) => {
      const node = document.importNode(c, true);
      guardPersonalized(node);
      track.appendChild(node);
    });
    liveBox.hidden = false;
    updateNav(liveBox);
    track.addEventListener('scroll', () => updateNav(liveBox), { passive: true });
  }

  function updateNav(box) {
    const t = box.querySelector('.bt-upsell__track');
    const [prev, next] = box.querySelectorAll('.bt-upsell__nav');
    if (!t || !prev || !next) return;
    prev.disabled = t.scrollLeft <= 2;
    next.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 2;
  }

  function cardVariant(card) {
    let variants = [];
    try { variants = JSON.parse(card.querySelector('[data-variants]').textContent); } catch (e) { return null; }
    const selects = [...card.querySelectorAll('.bt-upcard__select')];
    if (!selects.length) return variants[0] || null;
    const chosen = selects.map((s) => s.value);
    return variants.find((v) => chosen.every((val, i) => v.o[i] === val)) || null;
  }

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  /* Events (delegated, survive re-renders) */
  document.addEventListener('click', async (e) => {
    const d = e.target.closest('cart-drawer');
    if (!d) return;

    if (e.target.id === 'CartDrawer-Overlay') { d.close(); return; }

    const qtyBtn = e.target.closest('[data-bt-qty]');
    if (qtyBtn) {
      e.preventDefault();
      change(qtyBtn.dataset.key, Math.max(0, Number(qtyBtn.dataset.btQty)));
      return;
    }

    const nav = e.target.closest('.bt-upsell__nav');
    if (nav) {
      const track = nav.closest('.bt-upsell').querySelector('.bt-upsell__track');
      const card = track.querySelector('.bt-upcard');
      const step = card ? card.getBoundingClientRect().width + 10 : track.clientWidth;
      track.scrollBy({ left: Number(nav.dataset.dir) * step, behavior: 'smooth' });
      return;
    }

    const addBtn = e.target.closest('[data-bt-upsell-add]');
    if (addBtn) {
      const card = addBtn.closest('.bt-upcard');
      const v = cardVariant(card);
      if (!v || !v.a) {
        addBtn.textContent = 'Sold out';
        addBtn.classList.add('is-soldout');
        setTimeout(() => { addBtn.textContent = 'Add to cart'; addBtn.classList.remove('is-soldout'); }, 1600);
        return;
      }
      addBtn.textContent = 'Adding…';
      const ok = await add(v.id, 1);
      if (!ok) addBtn.textContent = 'Add to cart';
    }
  });

  document.addEventListener('change', (e) => {
    if (!e.target.closest('#CartDrawer')) return;

    if (e.target.matches('[data-bt-protection]')) {
      const r = cartRoot();
      if (!r) return;
      if (e.target.checked) {
        setOptOut(false);
        add(r.dataset.protVariant, 1);
      } else {
        setOptOut(true);
        if (r.dataset.protKey) change(r.dataset.protKey, 0);
      }
      return;
    }

    if (e.target.matches('.bt-upcard__select')) {
      const card = e.target.closest('.bt-upcard');
      const v = cardVariant(card);
      const price = card.querySelector('[data-price]');
      if (v && price) price.textContent = money(v.p);
    }
  });

  /* Hook Dawn product forms / quick add: run sync after Dawn renders the drawer */
  customElements.whenDefined('cart-drawer').then(() => {
    const C = customElements.get('cart-drawer');
    const original = C.prototype.renderContents;
    C.prototype.renderContents = function (parsedState) {
      original.call(this, parsedState);
      setTimeout(afterRender, 0);
    };
    afterRender();
  });
})();